@if (menuItem(); as menuItem) {
  @if (isLoading()) {
    <div class="menu-item menu-item--loading">
      <ftr-loader [isLoading]="true" [iconOnly]="true" [color]="COLOR.Primary50" [size]="LOADER_SIZE.Small" />
    </div>
  } @else {
    @if (isLink(menuItem)) {
      <a
        class="menu-item menu-item--interactive"
        [routerLink]="menuItem.path"
        [target]="menuItem.openInNewWindow ? '_blank' : undefined"
        [rel]="menuItem.openInNewWindow ? 'noopener noreferrer' : null"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    } @else if (isButton(menuItem)) {
      <button
        class="menu-item menu-item--interactive"
        [class]="{
          'menu-item--destructive': menuItem.isDestructive,
        }"
        (click)="menuItem.action()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </button>
    } @else {
      <div class="menu-item menu-item--static">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    }
  }

  <ng-template #content>
    <div class="menu-item__content">
      @if (menuItem.icon) {
        <ftr-icon
          class="menu-item__icon"
          [icon]="menuItem.icon"
          [style.color]="menuItem.iconColor ?? defaultIconColor()"
          size="Text"
          aria-hidden="true"
        />
      }
      <span class="menu-item__label" [style.color]="menuItem.labelColor">{{ menuItem.label }}</span>

      @if (isSelectableButton(menuItem)) {
        <div class="menu-item__right-section">
          <ftr-icon
            class="menu-item__icon"
            icon="Checkmark"
            color="Grey40"
            size="Text"
            [style.visibility]="menuItem.isSelected ? 'visible' : 'hidden'"
          />
        </div>
      }

      @if (shouldShowOpenInNewWindowIcon()) {
        <div class="menu-item__right-section">
          <ftr-icon class="menu-item__icon" icon="OpenInNew" color="Grey40" size="Text" aria-hidden="true" />
        </div>
      }
    </div>

    @if (menuItem.secondaryText) {
      <div class="menu-item__secondary-content">
        <span class="menu-item__secondary-text">
          {{ menuItem.secondaryText }}
        </span>
      </div>
    }
  </ng-template>
}
